// SPDX-FileCopyrightText: Copyright 2026 E-Chat
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial

import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage, FormattedMessage } from "react-intl";

import { wellKnownQuery } from "@/api/matrix";
import { GroupVerification } from "@/components/group-verification";
import * as Navigation from "@/components/navigation";
import * as Page from "@/components/page";
import AppFooter from "@/ui/footer";

const titleMessage = defineMessage({
  id: "echat.verification.labels_title",
  defaultMessage: "Verification labels",
  description:
    "Title of the verification labels management page and navigation item",
});

export const Route = createFileRoute("/_console/verification-labels")({
  staticData: {
    breadcrumb: {
      message: titleMessage,
    },
  },
  loader: async ({ context: { queryClient, credentials } }) => {
    await queryClient.ensureQueryData(wellKnownQuery(credentials.serverName));
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { credentials } = Route.useRouteContext();
  const { data: wellKnown } = useSuspenseQuery(
    wellKnownQuery(credentials.serverName),
  );

  return (
    <Navigation.Content>
      <Navigation.Main>
        <Page.Header>
          <Page.Title>
            <FormattedMessage {...titleMessage} />
          </Page.Title>
        </Page.Header>
        <div className="max-w-2xl">
          <GroupVerification root={wellKnown["m.homeserver"].base_url} />
        </div>
      </Navigation.Main>
      <AppFooter />
    </Navigation.Content>
  );
}
